import { useEffect } from 'react';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover';
import FJPhotoRemoveBgLeft from '../view/FJPhotoRemoveBgLeft';
import { useSelector, useDispatch } from 'react-redux';
import FJActionAiHistoryCommon from '../../../../redux/action/FJActionAiHistoryCommon';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJPhotoRemoveBgLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const curMenuIndex = useSelector(state => state.photoBgRemover.curMenuIndex);

    useEffect(() => {
        window.addEventListener('storage', function (event) {
            if (event.key === 'communicationKey') {
                try {
                    dispatch(FJActionAiHistoryCommon.initAiTextToImageHistoryList(true));
                } catch (e) {
                    console.log(e);
                }
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const switchCurMenuIndex = index => {
        dispatch(FJActionPhotoBgRemover.switchCurMenuIndex(index));
    };

    return <FJPhotoRemoveBgLeft curMenuIndex={curMenuIndex} switchCurMenuIndex={switchCurMenuIndex} />;
};

export default FJPhotoRemoveBgLeftContainer;
